/* eslint-disable no-unused-vars */
export const green = '#A0C513';
export const darkgrey = '#CCCCCC';
export const offwhite = '#F0F0F0';
export const black = '#000000';
export const white = '#FFFFFF';
export const grey = '#D9D9D9';
export const lightgrey = '#DEDDDE';
export const lightergrey = '#999999';
export const lightergreyAlternative = '#F5F5F5';
export const liightergrey = '#F7F7F7';
export const borderColor = '#F2F2F2';
export const boxShadowColor = '#0000001A';
export const red = '#DA3732';
export const lightRed = '#FAE6E5';
export const errorRed = '#ED1C29';
